var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('th',[_vm._v("Gxptest")]),_c('th',[_vm._v("Gxpdate")]),_c('th',[_vm._v("Gxpres")])])
}
var staticRenderFns = []

export { render, staticRenderFns }